var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { getReviewWidgetStyles } from './ReviewWidgetStyles';
import { BLACK, BLACK_700, BLACK_900, Badge, Divider, LILAC_400, Typography, WHITE, isLastItem, useBreakpoint, Button, InfoTag, IconButton, DynamicSvg } from '@airtel/air-design-system';
import { CardTitleWidget } from '../card-title-widget';
import { FlatList, Image, TouchableOpacity, View } from 'react-native';
import { ButtonWidget } from '../button-widget';
export var ReviewWidgetComponent = props => {
  var cardMainTitleWidget = props.cardMainTitleWidget,
    title = props.title,
    subTitle = props.subTitle,
    heading = props.heading,
    subHeading = props.subHeading,
    description = props.description,
    descriptionToggleButton = props.descriptionToggleButton,
    infoIconName = props.infoIconName,
    infoText = props.infoText,
    _props$thumbnails = props.thumbnails,
    thumbnails = _props$thumbnails === void 0 ? [] : _props$thumbnails,
    onUserAction = props.onUserAction,
    isLastReview = props.isLastReview,
    buttonWidgetProps = props.buttonWidgetProps,
    screenBreakpoint = props.screenBreakpoint,
    id = props.id,
    infoTagWidget = props.infoTagWidget,
    infoTagWidgetIconName = props.infoTagWidgetIconName,
    likeDislikeWidget = props.likeDislikeWidget,
    bottomCta = props.bottomCta,
    showInfoIcon = props.showInfoIcon,
    infoIconTooltipText = props.infoIconTooltipText,
    infoTagType = props.infoTagType,
    _props$reviewWidgetIc = props.reviewWidgetIcons,
    reviewWidgetIcons = _props$reviewWidgetIc === void 0 ? [] : _props$reviewWidgetIc,
    cardTitleWidgetProps = props.cardTitleWidgetProps,
    restProps = __rest(props, ["cardMainTitleWidget", "title", "subTitle", "heading", "subHeading", "description", "descriptionToggleButton", "infoIconName", "infoText", "thumbnails", "onUserAction", "isLastReview", "buttonWidgetProps", "screenBreakpoint", "id", "infoTagWidget", "infoTagWidgetIconName", "likeDislikeWidget", "bottomCta", "showInfoIcon", "infoIconTooltipText", "infoTagType", "reviewWidgetIcons", "cardTitleWidgetProps"]);
  var reviewWidgetStyles = getReviewWidgetStyles();
  var _useState = useState(false),
    isShow = _useState[0],
    setIsShow = _useState[1];
  var _useState2 = useState(false),
    isSelected = _useState2[0],
    setIsSelected = _useState2[1];
  var _useState3 = useState(),
    itemIndex = _useState3[0],
    setItemIndex = _useState3[1];
  var breakpoint = useBreakpoint();
  var newBreakpoint = screenBreakpoint ? screenBreakpoint : breakpoint;
  var isLargeScreen = newBreakpoint == 'xl' || newBreakpoint == 'lg';
  var isMediumScreen = newBreakpoint == 'lg' || newBreakpoint == 'md';
  var typographyTypes = {
    heading: isLargeScreen ? 'body-single-line-lg-bold' : 'body-single-line-md-bold',
    subHeading: isLargeScreen ? 'body-para-md' : 'body-para-sm',
    description: isLargeScreen ? 'body-para-md' : 'body-para-sm',
    infoText: isLargeScreen ? 'title-single-line-md' : 'title-single-line-md'
  };
  var sizeTypes = {
    descriptionToggleButton: isMediumScreen ? 'md' : 'sm',
    infoTagWidget: isMediumScreen ? 'md' : 'sm'
  };
  var toggleHandler = () => {
    setIsShow(!isShow);
  };
  var handleSelected = index => {
    setItemIndex(index);
    if (index !== itemIndex) {
      setIsSelected(true);
    }
  };
  var descriptionText = () => {
    if (!descriptionToggleButton || (description === null || description === void 0 ? void 0 : description.length) < 80) {
      return description;
    } else {
      if (isShow) {
        return description;
      } else {
        return (description === null || description === void 0 ? void 0 : description.slice(0, 80)) + '...';
      }
    }
  };
  return _jsxs(View, Object.assign({}, restProps, {
    children: [cardMainTitleWidget && _jsx(CardTitleWidget, Object.assign({
      title: title,
      subTitle: subTitle,
      showInfoIcon: showInfoIcon,
      infoIconTooltipProps: {
        text: infoIconTooltipText,
        autoHide: true
      }
    }, cardTitleWidgetProps)), !!heading && _jsx(Typography, {
      type: typographyTypes.heading,
      color: BLACK_900,
      text: heading,
      style: [cardMainTitleWidget && reviewWidgetStyles.heading, reviewWidgetStyles.tooltip]
    }), !!subHeading && _jsx(Typography, {
      type: typographyTypes.subHeading,
      color: BLACK_700,
      text: subHeading,
      style: [reviewWidgetStyles.subHeading, reviewWidgetStyles.tooltip]
    }), !!description && _jsxs(_Fragment, {
      children: [_jsx(Typography, {
        type: typographyTypes.description,
        color: BLACK_900,
        text: descriptionText(),
        style: reviewWidgetStyles.description
      }), !!descriptionToggleButton && description.length > 80 && _jsx(Button, {
        style: reviewWidgetStyles.toggleButton,
        title: isShow ? 'Show Less' : 'Show More',
        buttonType: "tertiary",
        size: sizeTypes.descriptionToggleButton,
        version: "fixed-padding",
        onPress: toggleHandler
      })]
    }), _jsxs(View, Object.assign({
      style: (infoIconName || infoText) && reviewWidgetStyles.infoContainer
    }, {
      children: [!!infoIconName && _jsx(DynamicSvg, {
        iconName: infoIconName,
        fontSize: 16,
        color: BLACK,
        style: reviewWidgetStyles.infoIcon
      }), !!infoText && _jsx(Typography, {
        type: typographyTypes.infoText,
        color: BLACK_700,
        text: infoText
      })]
    })), !!infoTagWidget && _jsx(View, Object.assign({
      style: [reviewWidgetStyles.infoTagWidgetContainer]
    }, {
      children: _jsx(InfoTag, {
        text: infoTagWidget,
        subType: infoTagType,
        iconName: infoTagWidgetIconName,
        size: sizeTypes.infoTagWidget,
        style: reviewWidgetStyles.infoIcon
      })
    })), !!thumbnails.length && _jsx(FlatList, {
      data: thumbnails,
      horizontal: true,
      keyboardShouldPersistTaps: "handled",
      renderItem: _ref => {
        var item = _ref.item,
          index = _ref.index;
        return _jsxs(View, Object.assign({
          style: [reviewWidgetStyles.thumbnailContaner, !isLastItem(thumbnails, index) && reviewWidgetStyles.thumbnailRightSpacing]
        }, {
          children: [(item === null || item === void 0 ? void 0 : item.imageUrl) && _jsx(TouchableOpacity, Object.assign({
            onPress: () => (item === null || item === void 0 ? void 0 : item.onPress) && onUserAction(Object.assign({
              id
            }, item === null || item === void 0 ? void 0 : item.onPress), {
              index,
              itemData: item
            })
          }, {
            children: _jsx(Image, {
              source: {
                uri: item.imageUrl,
                height: 72,
                width: 72
              },
              style: reviewWidgetStyles.thumbnailImage
            })
          })), (item === null || item === void 0 ? void 0 : item.imageName) && _jsx(Badge, {
            size: "sm",
            label: item === null || item === void 0 ? void 0 : item.imageName,
            style: reviewWidgetStyles.thumbnailText,
            onPress: () => (item === null || item === void 0 ? void 0 : item.onPress) && onUserAction(Object.assign({
              id
            }, item === null || item === void 0 ? void 0 : item.onPress), {
              index,
              itemData: item
            })
          })]
        }), "thumbnain-item-" + index);
      },
      showsHorizontalScrollIndicator: false,
      keyExtractor: (_, index) => "thumbnain-item-" + index
    }), likeDislikeWidget && _jsxs(View, Object.assign({
      style: reviewWidgetStyles.likeDislikeContainer
    }, {
      children: [_jsx(Typography, {
        type: typographyTypes.heading,
        color: BLACK_900,
        text: likeDislikeWidget
      }), _jsx(View, Object.assign({
        style: reviewWidgetStyles.likeDislikeIcons
      }, {
        children: reviewWidgetIcons === null || reviewWidgetIcons === void 0 ? void 0 : reviewWidgetIcons.map((item, index) => {
          return _jsx(IconButton, {
            size: "md",
            type: "secondary",
            onPress: () => {
              (item === null || item === void 0 ? void 0 : item.onPressMetaData) && onUserAction(Object.assign({
                id
              }, item === null || item === void 0 ? void 0 : item.onPressMetaData), {
                index,
                itemData: item
              });
              handleSelected(index);
            },
            selected: index == itemIndex ? isSelected : false,
            style: index > 0 && reviewWidgetStyles.horizontalSpace,
            iconName: item.iconName
          }, index);
        })
      }))]
    })), bottomCta && _jsx(ButtonWidget, Object.assign({
      style: reviewWidgetStyles.bottomCta,
      leftCta: {
        title: bottomCta,
        size: 'sm',
        buttonType: 'secondary',
        version: 'variable-width'
      }
    }, buttonWidgetProps, {
      onUserAction: onUserAction
    })), !isLastReview && _jsx(Divider, {
      height: 2,
      color: LILAC_400,
      shadowColor: WHITE,
      style: reviewWidgetStyles.divider
    })]
  }));
};
ReviewWidgetComponent.genericRendererKey = 'AirReviewWidget';